module.exports = {
  "id": "a017e5b3-f8ef-40b1-a468-f9cc88872483",
  "gtmIds": [
    "GTM-KVRZ5DG3",
    " GTM-PCQMH4P5"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "Aussois",
  "language": "fr-FR",
  "defaultDateFormat": {
    "id": 1,
    "format": "DD/MM/YYYY",
    "name": "Numeric Day First (23/04/2026)"
  },
  "defaultNumberFormat": {
    "id": 3,
    "name": "European (Dot thousands, Comma decimals)",
    "format": "#.###,##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "fr-FR",
    "en-US"
  ],
  "website": "https://www.aussois360.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}